const state = {
  appHost: null,
  appSavitarna: false,
  appBaseApi: null,
  savitarnaCartUrl: null,
  savitarnaHomeUrl: null,
  savitarnaBreadcrumbs: [],
}

// getters
const getters = {
  appHost: (state) => state.appHost,
  appSavitarna: (state) => state.appSavitarna,
  appPublic: (state) => state.appPublic,
  appBaseApi: (state) => state.appBaseApi,
  savitarnaCartUrl: (state) => state.savitarnaCartUrl,
  savitarnaHomeUrl: (state) => state.savitarnaHomeUrl,
  savitarnaBreadcrumbs: (state) => state.savitarnaBreadcrumbs,
}

// actions
const actions = {
  setAppHost({ commit, dispatch }, locationData) {
    let host = locationData.host
    let pathname = locationData.pathname
    const savitarna = host === process.env.VUE_APP_SAVITARNA_HOST
    const publicSearch = pathname === process.env.VUE_APP_PUBLIC_PATH
    // const publicSearch = host === process.env.VUE_APP_PUBLIC_HOST
    dispatch('appHost', host)
    dispatch('appSavitarna', savitarna)
    dispatch('appPublic', publicSearch)
    dispatch(
      'appBaseApi',
      savitarna
        ? process.env.VUE_APP_SAVITARNA_BASE_API
        : process.env.VUE_APP_BASE_API
    )
  },
  appHost({ commit }, payload) {
    commit('appHost', payload)
  },
  appSavitarna({ commit }, payload) {
    commit('appSavitarna', payload)
  },
  appPublic({ commit }, payload) {
    commit('appPublic', payload)
  },
  appBaseApi({ commit }, payload) {
    commit('appBaseApi', payload)
  },
  savitarnaCartUrl({ commit }, payload) {
    commit('savitarnaCartUrl', payload)
  },
  savitarnaHomeUrl({ commit }, payload) {
    commit('savitarnaHomeUrl', payload)
  },
  savitarnaBreadcrumbs({ commit }, payload) {
    commit('savitarnaBreadcrumbs', payload)
  },
}

// mutations
const mutations = {
  appHost(state, data) {
    state.appHost = data
  },
  appSavitarna(state, data) {
    state.appSavitarna = data
  },
  appPublic(state, data) {
    state.appPublic = data
  },
  appBaseApi(state, data) {
    state.appBaseApi = data
  },
  savitarnaCartUrl(state, data) {
    state.savitarnaCartUrl = data
  },
  savitarnaHomeUrl(state, data) {
    state.savitarnaHomeUrl = data
  },
  savitarnaBreadcrumbs(state, data) {
    state.savitarnaBreadcrumbs = data
  },
}

export default {
  namespace: true,
  state,
  getters,
  actions,
  mutations,
}
